import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CreateTrialEnrollmentPayload {
  studentId: string;
  classId: string;
  /** ISO strings from GHL slot selection */
  trialStartTimeISO?: string;
  trialEndTimeISO?: string;
  /** For custom time (alternative to slot) */
  trialStartDate?: string;
  trialStartTime?: string;
  trialEndTime?: string;
  notes?: string;
}

export const createTrialEnrollment = async (
  payload: CreateTrialEnrollmentPayload,
) => {
  const response = await baseAPI.post(
    '/trialstudents/manual-enrollment',
    payload,
  );
  return response.data;
};

export const useCreateTrialEnrollment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createTrialEnrollment,
    onSuccess: (_data, variables) => {
      toast.success('Trial class enrolled successfully');
      void queryClient.invalidateQueries({ queryKey: [KEYS.STUDENTS] });
      void queryClient.invalidateQueries({ queryKey: [KEYS.TRIAL_STUDENTS] });
      void queryClient.invalidateQueries({ queryKey: [KEYS.TRIAL_CONVERSION] });
      void queryClient.invalidateQueries({ queryKey: [KEYS.CLASSES] });
      void queryClient.refetchQueries({
        queryKey: [KEYS.STUDENTS, variables.studentId],
      });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message || 'Failed to enroll trial class',
      );
    },
  });
};
